// extracted by mini-css-extract-plugin
module.exports = {"mask":"_5D2oxz1d","is-open":"_5D3TKWmH","is-fixed":"_5DnmKJtA","content":"_5DnExn0b"};